import { render, staticRenderFns } from "./SortCaret.vue?vue&type=template&id=26f0bffb&"
import script from "./SortCaret.vue?vue&type=script&lang=js&"
export * from "./SortCaret.vue?vue&type=script&lang=js&"
import style0 from "./SortCaret.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports